import React, { Component } from 'react';
import * as background from './assets/EnlightenWebBackground4.jpg';
import * as icon from './assets/WebIcon.png';
import * as logo from './assets/WebLogo.png';
import * as personalizedIcon from './assets/PersonalizedIcon.png';
import * as guidedIcon from './assets/GuidedIcon.png';
import * as evidenceBasedIcon from './assets/EvidenceBasedIcon.png';
import * as adaptiveIcon from './assets/AdaptiveIcon.png';
import * as comprehensiveIcon from './assets/ComprehensiveIcon.png';
import * as screenshot1 from './assets/WebScreenshot5.png';
import * as screenshot2 from './assets/WebScreenshot4.png';
import * as twitterIcon from './assets/TwitterIcon.png';
import * as facebookIcon from './assets/FacebookIcon.png';
import * as instagramIcon from './assets/InstagramIcon.png';
import * as playStoreButton from './assets/PlayStoreComingSoon.png';
import * as appStoreButton from './assets/AppStoreButton.png';
import './App.css';

class App extends Component {
  componentDidMount() {
    document.title = 'Enlighten'
  }

  render() {
    return (
      <div className="App">
        <img src={background} className="Background-image"/>
        <div className="Block1">
          <header className="Header">
            <p className="Logo-text"> 
              <img src={logo} className="Logo"/> 
                Enlighten
            </p>
            <div className="Menu">
              <p className="Menu-item" onClick={() => window.scrollTo(0, 645)}>
                About
              </p>
              <p className="Menu-item" onClick={() => window.scrollTo(0, 1560)}>
                Features
              </p>
              <p className="Menu-item" onClick={() => window.scrollTo(0, 2220)}>
                Contact us
              </p>
            </div>
          </header>
          <div className="Title-view">
            <p className="Slogan">
              Wellbeing, simplified.
              <p className="Tagline">
                Your personalized, evidence-based guide to improving wellbeing and mental health.
              </p>
            </p>
            <img src={screenshot2} className="Phone"/>
          </div>
          <div className="Button-view">
            <a href="https://itunes.apple.com/us/app/enlighten-wellbeing-simplified/id1356009866?mt=8" target="_blank" rel="noopener noreferrer">
              <img src={appStoreButton} className="Button"/>
            </a>
            <img src={playStoreButton} className="Button"/>
          </div>
      </div>
      <div className="Block2">
      <div className="About-column-1">
        <p className="About-header">
          Your personalized wellbeing guide.
        </p>
          <div className="About-item">
            <img src={personalizedIcon} className="Circle"/>
            <p className="About-item-header">
              Personalized 
              <p className="About-item-description">
                We use clinically-validated assessments paired with intelligent data analysis 
                to meet your personal needs.
              </p>
            </p>
          </div>
          <div className="About-item">
            <img src={guidedIcon} className="Circle"/>
            <p className="About-item-header">
              Guided 
              <p className="About-item-description">
                Enlighten provides daily guidance so you don’t have to worry about 
                how to be happier—you just do it.
              </p>
            </p>
          </div>
          <div className="About-item">
            <img src={evidenceBasedIcon} className="Circle"/>
            <p className="About-item-header">
              Evidence-based 
              <p className="About-item-description">
                Scientifically-validated exercises harness neuroplasticity 
                to help you rewire your brain for positive growth.
              </p>
            </p>
          </div>
        </div>
        <div className="About-column-2">
          <div className="About-item">
          <img src={adaptiveIcon} className="Circle"/>
          <p className="About-item-header">
            Adaptive 
            <p className="About-item-description">
            Enlighten learns from you over time to optimize your path to progress.
            </p>
          </p>
        </div>
          <div className="About-item">
            <img src={comprehensiveIcon} className="Circle"/>
            <p className="About-item-header">
              Comprehensive
              <p className="About-item-description">
                From assessment and treatment to habit tracking, support for anxiety and depression, and more, 
                we offer a truly comprehensive wellbeing experience.
              </p>
            </p>
          </div>
        </div>
      </div>
      <div className="Block3">
        <p className="Question">
          How does it work?
          <p className="Answer">
            Enlighten creates a personalized, guided track for you using your questionnaire
            responses to develop a program that's scientifically designed 
            to boost happiness, reduce stress, and help you improve your wellbeing and 
            mental health. Enlighten learns from you and checks in over time so your 
            track is always customized to suit your needs and deliver optimal results.
          </p>
        </p>
        <img src={icon} className="Icon"/>
      </div>
      <div className="Block4">
        <div className="About-column-1">
          <p className="About-header">
            Evidence-based features. 
          </p>
          <div className="Feature-view">
            <div className="Feature-column">
              <p className="Feature-header">
                Validated exercises
                <p className="Feature-description">
                  Empirically-supported activities from cognitive behavioral therapy,
                  positive psychology, mindfulness, and more. 
                </p>
              </p>
              <p className="Feature-header">
                Assessment 
                <p className="Feature-description">
                  Screening questionnaires help you better understand your own wellbeing 
                  and mental health and chart them over time.
                </p>
              </p>
              <p className="Feature-header">
                Habit tracking
                <p className="Feature-description">
                  Track your mood and habits to see how they interact with each other 
                  and gain better insight into what makes you happy.
                </p>
              </p>
            </div>
            <div className="Feature-column">
              <p className="Feature-header">
                Meditation
                <p className="Feature-description">
                  Meditation made easy. We offer a simple, scientific explanation of meditation,
                  and the tools you need to make it work for you.
                </p>
              </p>
              <p className="Feature-header">
                Lessons
                <p className="Feature-description">
                  Learn strategies, exercises, skills, and tips for enhanced wellbeing and a happier life.
                </p>
              </p>
              <p className="Feature-header">
                Support for depression and anxiety
                <p className="Feature-description">
                Enlighten includes lessons, exercises, tracking tools, and questionnaires designed to alleviate depression and anxiety. 
                </p>
              </p>
            </div>
          </div>
        </div>
        <img src={screenshot1} className="Phone-2"/>
      </div>
      <div className="Block5">
        <p className="Contact-us">
          Contact us
          <p className="Contact-info">
            We’d love to hear from you. You can get in touch with us via email or 
            social media, or by leaving an App Store review. 
          </p>
        </p>
        <div className="Feature-view">
          <p className="Contact-item">
            Email 
            <p className="Contact-item-description">
              support@enlightenlabs.com
            </p>
          </p>
          <p className="Contact-item">
            Social media
            <div className="Feature-view">
              <a href="https://www.facebook.com/TheEnlightenApp" target="_blank" rel="noopener noreferrer">
                <img src={facebookIcon} className="Social-icon"/>
              </a>
              <a href="https://twitter.com/TheEnlightenApp" target="_blank" rel="noopener noreferrer">
                <img src={twitterIcon} className="Social-icon"/>
              </a>
              <a href="https://www.instagram.com/theenlightenapp" target="_blank" rel="noopener noreferrer">
                <img src={instagramIcon} className="Social-icon"/>
              </a>
            </div>
          </p>
        </div>
      </div>
    </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js